import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import {
    GET_SHARE_TEMPLATE_SUCCESS,
    GET_SHARE_TEMPLATE_FAILURE
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

import {
    shareTemplateService,
} from 'src/pages/more/pages/templates/redux/services/index.js';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export function* shareTemplate(action) {
    try {
        const result = yield shareTemplateService(action.payload);
        yield put({ type: GET_SHARE_TEMPLATE_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/order/templates/share`,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_SHARE_TEMPLATE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}